<template>
  <v-card class="mb-8 tableDetalle">
    <v-card-title primary-title class="py-2">
      <v-toolbar-title>{{ $t("view.bases.base.fragment.detalle") }}</v-toolbar-title>
      <v-spacer />
      <v-btn icon style="margin: 0" @click="view.elem.datatable.visible = !view.elem.datatable.visible">
        <v-icon>{{ view.elem.datatable.visible ? "keyboard_arrow_down" : "keyboard_arrow_up" }}</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text v-show="view.elem.datatable.visible" class="py-0">
      <v-layout row wrap>
        <v-flex md12>
          <v-data-table
            ref="datatableDetalle"
            item-key="clave"
            class="detalle dataTable"
            sort-by="clave"
            :sort-desc="true"
            :headers="view.elem.datatable.headers"
            :items="view.elem.datatable.data"
            :loading="view.elem.datatable.loading"
            :footer-props="view.elem.datatable.footerprops"
            :must-sort="true"
            :server-items-length="view.elem.datatable.total"
            :options.sync="options">
            <template #item.fechaFinPromo="{ item }">
              {{ formatDate(item.fechaFinPromo) }}
            </template>
            <template #item.se="{ item }">
              <div v-if="item.se" class="d-inline-flex align-center">
                <span>{{ fixSe(item.se) }}</span>
                <v-chip class="ml-1" dense x-small :color="SE_NEGOCIO_TABLE[item.negocio].color">
                  <strong>{{ item.negocio }}</strong>
                </v-chip>
              </div>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import BaseAPI from "@/services/bases/base";
import transform from "@/helpers/server-side-datatable";
import tippy from "tippy.js";
import { formatDate } from "@/helpers/date-methods";
import { fixSe } from "@/helpers/form-common";

import { SE_NEGOCIO_TABLE } from "@/constants/operativos";

export default {
  name: "DetalleModal"
  , data() {
    return {
      titleModal: this.$t("view.commons.detail")
      , tbase: {}
      , options: {}
      , SE_NEGOCIO_TABLE
      , view: {
        elem: {
          datatable: {
            visible: true
            , loading: false
            , filtros: {}
            , data: []
            , total: 0
            , footerprops: { showFirstLastPage: true, "items-per-page-options": [10, 25, 50, 100] }
            , headers: [
              { text: this.$t("#"), align: "center", sortable: true, class: "tablaHeader clave", value: "clave" }
              , { text: this.$t("view.bases.base.detalle.campana"), align: "left", sortable: true, class: "tablaHeader campana", value: "campana" }
              , { text: this.$t("view.bases.base.detalle.se"), align: "left", sortable: true, class: "tablaHeader se", value: "se" }
              , { text: this.$t("view.bases.base.detalle.cuit"), align: "center", sortable: true, class: "tablaHeader cuit", value: "cuit" }
              , { text: this.$t("view.bases.base.detalle.nombre"), align: "left", sortable: true, class: "tablaHeader nombre", value: "nombre" }
              , { text: this.$t("view.bases.base.detalle.razonSocial"), align: "left", sortable: true, class: "tablaHeader razonSocial", value: "razonSocial" }
              , { text: this.$t("view.bases.base.detalle.codigoIndustrial"), align: "center", sortable: true, class: "tablaHeader codigoIndustrial", value: "codigoIndustrial" }
              , { text: this.$t("view.bases.base.detalle.acuerdo"), align: "left", sortable: true, class: "tablaHeader acuerdo", value: "acuerdo" }
              , { text: this.$t("view.bases.base.detalle.subIndustria"), align: "left", sortable: true, class: "tablaHeader subIndustria", value: "subIndustria" }
              , { text: this.$t("view.bases.base.detalle.direccion"), align: "left", sortable: true, class: "tablaHeader direccion", value: "direccion" }
              , { text: this.$t("view.bases.base.detalle.altura"), align: "left", sortable: true, class: "tablaHeader altura", value: "altura" }
              , { text: this.$t("view.bases.base.detalle.localidad"), align: "left", sortable: true, class: "tablaHeader localidad", value: "localidad" }
              , { text: this.$t("view.bases.base.detalle.provincia"), align: "left", sortable: true, class: "tablaHeader provincia", value: "provincia" }
              , { text: this.$t("view.bases.base.detalle.cp"), align: "center", sortable: true, class: "tablaHeader cp", value: "cp" }
              , { text: this.$t("view.bases.base.detalle.telefono"), align: "center", sortable: true, class: "tablaHeader telefono", value: "telefono" }
              , { text: this.$t("view.bases.base.detalle.email"), align: "left", sortable: true, class: "tablaHeader email", value: "email" }
              , { text: this.$t("view.bases.base.detalle.banco"), align: "left", sortable: true, class: "tablaHeader banco", value: "banco" }
              , { text: this.$t("view.bases.base.detalle.pos"), align: "center", sortable: true, class: "tablaHeader pos", value: "pos" }
              , { text: this.$t("view.bases.base.detalle.ahora12"), align: "center", sortable: true, class: "tablaHeader ahora12", value: "ahora12" }
              , { text: this.$t("view.bases.base.detalle.benefPref"), align: "center", sortable: true, class: "tablaHeader benefPref", value: "benefPref" }
              , { text: this.$t("view.bases.base.detalle.fechaFinPromo"), align: "center", sortable: true, class: "tablaHeader fechaFinPromo", value: "fechaFinPromo" }
              , { text: this.$t("view.bases.base.detalle.vendor"), align: "left", sortable: true, class: "tablaHeader vendor", value: "vendor" }
              , { text: this.$t("view.bases.base.detalle.tipoContacto"), align: "center", sortable: true, class: "tablaHeader tipoContacto", value: "tipoContacto" }
              , { text: this.$t("view.bases.base.detalle.flag"), align: "center", sortable: true, class: "tablaHeader flag", value: "flag" }
              , { text: this.$t("view.bases.base.detalle.status"), align: "center", sortable: true, class: "tablaHeader status", value: "status" }
            ]
          }
        }
      }
    };
  }
  , watch: {
    options: {
      handler() {
        this.load();
      }
      , deep: true
    }
    , search: {
      handler() {
        this.options.page = 1;
        this.load();
      }
      , deep: true
    }
  }
  , updated() {
    this.$nextTick(function () {
      tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
    });
  }
  , methods: {
    open(clave) {
      this.filtros = {};
      this.filtros.base = clave;
      this.options = { page: 1, itemsPerPage: 10, sortBy: ["clave"], sortDesc: [true], groupBy: [], groupDesc: [], mustSort: true, multiSort: false };
      if (clave) this.load();
    }
    , prepareData() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      let serverSideData = {};
      serverSideData.draw = "0";
      serverSideData.filters = JSON.stringify(this.filtros);
      serverSideData.start = page;
      serverSideData.length = itemsPerPage;
      serverSideData.search = { value: this.search ? this.search : "", regex: false };
      serverSideData.order = { column: sortBy, dir: sortDesc };
      serverSideData.columns = this.view.elem.datatable.headers;
      return transform.transformServerSideRequest(serverSideData);
    }
    , async load() {
      if (!this.filtros || this.filtros == {}) return false;
      this.view.elem.datatable.loading = true;

      const serverSideDataT = this.prepareData();
      const response = await BaseAPI.listDetalle(serverSideDataT);
      const { data, recordsTotal } = response.data;

      this.view.elem.datatable.data = data;
      this.view.elem.datatable.total = Number(recordsTotal);

      this.view.elem.datatable.loading = false;
    }
    , formatDate
    , fixSe
  }
};
</script>

<style>
.tableDetalle .clave {
  width: 80px !important;
  min-width: 80px !important;
}

.tableDetalle .direccion {
  width: 400px !important;
  min-width: 400px !important;
}

.tableDetalle .altura {
  width: 80px !important;
  min-width: 80px !important;
}

.tableDetalle .subIndustria {
  width: 300px !important;
  min-width: 300px !important;
}

.tableDetalle .codigoIndustrial {
  min-width: 150px !important;
}

.tableDetalle .ahora12 {
  min-width: 100px !important;
}

.tableDetalle .benefPref {
  min-width: 150px !important;
}

.tableDetalle .acuerdo {
  min-width: 130px !important;
}

.tableDetalle .fechaFinPromo {
  min-width: 150px !important;
}

.tableDetalle .vendor {
  min-width: 110px !important;
}

.tableDetalle .tipoContacto {
  min-width: 130px !important;
}

.tableDetalle .cp {
  min-width: 80px !important;
}

.tableDetalle .pos {
  min-width: 100px !important;
}

.tableDetalle .cuit {
  min-width: 130px !important;
}

.tableDetalle .flag {
  min-width: 500px !important;
}

.tableDetalle .email {
  min-width: 500px !important;
}

.tableDetalle .telefono {
  min-width: 400px !important;
}

.tableDetalle .provincia {
  min-width: 180px !important;
}

.tableDetalle .localidad {
  min-width: 300px !important;
}

.tableDetalle .razonSocial {
  min-width: 300px !important;
}

.tableDetalle .nombre {
  min-width: 300px !important;
}

.tableDetalle .campana {
  min-width: 200px !important;
}

.tableDetalle .banco {
  min-width: 400px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/bases/base/DataTableDetalle.vue